import { Translate } from '~/i18n';
import Modal from '~/components/common/modal';
import { Section } from '~/components/common/section';
import { CloseIcon } from '~/svgs';
import { Button } from '../common/button';

type RejectionModalProps = {
   reasons: any;
   closeModal: () => void;
   open: boolean;
   isRequireUpdate: boolean;
};

const RejectionModal = ({ reasons, closeModal, open, isRequireUpdate }: RejectionModalProps) => {
   return (
      <>
         <Modal size="md" open={open} onClickOutside={closeModal}>
            <Modal.Body>
               <Section className="relative">
                  <div className="flex items-center w-full p-6">
                     <div className="text-xl font-bold">
                        {isRequireUpdate ? (
                           <Translate id="visasManager:required update" />
                        ) : (
                           <Translate id="visasManager:reason for rejection" />
                        )}
                     </div>
                     <div
                        onClick={closeModal}
                        className="absolute flex justify-end cursor-pointer top-6 ltr:right-4 rtl:left-4">
                        <CloseIcon />
                     </div>
                  </div>
                  <hr />

                  <div className="p-6">
                     <div className="flex flex-col p-6 border rounded-xl">
                        <div className="mb-4 font-bold">
                           <Translate id="visasManager:missing documents" />
                        </div>
                        <div className="mb-4 text-sm">
                           <Translate id="visasManager:missing information" />
                        </div>
                        <ul className="text-sm list-disc list-inside ltr:ml-1 rtl:mr-1">
                           {reasons?.map((reason: any, index: number) => (
                              <li key={index}>{reason}</li>
                           ))}
                        </ul>
                        <div className="mt-2 text-sm">
                           <Translate id="visasManager:prepare note" />
                        </div>
                     </div>
                  </div>
                  <hr />
                  <div className="flex items-center justify-end px-6 py-3">
                     <Button theme="primary" onClick={closeModal} className="lg:!w-44">
                        <Translate id="common:exit" />
                     </Button>
                  </div>
               </Section>
            </Modal.Body>
         </Modal>
      </>
   );
};

export default RejectionModal;
